var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.3 13.202H13.7V11.002H9.3V13.202ZM9.3 9.90195H18.1V7.70195H9.3V9.90195ZM9.3 6.60195H18.1V4.40195H9.3V6.60195ZM7.1 17.602C6.495 17.602 5.97727 17.3867 5.5468 16.9563C5.1156 16.5251 4.9 16.007 4.9 15.402V2.20195C4.9 1.59695 5.1156 1.07885 5.5468 0.647653C5.97727 0.217186 6.495 0.00195312 7.1 0.00195312H20.3C20.905 0.00195312 21.4231 0.217186 21.8543 0.647653C22.2848 1.07885 22.5 1.59695 22.5 2.20195V15.402C22.5 16.007 22.2848 16.5251 21.8543 16.9563C21.4231 17.3867 20.905 17.602 20.3 17.602H7.1ZM7.1 15.402H20.3V2.20195H7.1V15.402ZM2.7 22.002C2.095 22.002 1.57727 21.7867 1.1468 21.3563C0.7156 20.9251 0.5 20.407 0.5 19.802V4.40195H2.7V19.802H18.1V22.002H2.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryIcon);
export default __webpack_public_path__ + "static/media/library_icon.1eac3a9b4c1ba8b6c8620e1b9c254de6.svg";
export { ForwardRef as ReactComponent };